import { createTheme } from "@material-ui/core/styles";

const appTheme = createTheme({
  palette: {
    primary: {
      main: "#658D1B",
      dark: "#466212",
      light: "#83a348",
    },
    secondary: {
      main: "#279989",
      dark: "#1b6b5f",
      light: "#52ada0",
    },
    error: {
      main: "#8f090e",
      dark: "#1b6b5f",
      light: "#d73d43",
    },
    warning: {
      main: "#FFB100",
      dark: "#b27b00",
      light: "#ffc033",
    },
    success: {
      main: "#68A300",
      dark: "#487200",
      light: "#86b533",
    },
    background: {
      paper: "#FAFAFA",
      white: "#FFFFFF",
    },
    red: {
      main: "#CD0D15",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
  sizes: {
    drawer: {
      mobileWidth: "100%",
      desktopWidth: 200,
    },
    spacing: {
      default: 24,
      minor: 20,
    },
  },
  typography: {
    fontFamily: "Arial",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 14,
    lineHeight: "15px",
    button: {
      textTransform: "capitalize",
      fontWeight: "bold",
    },
  },
});

const AppTypography = (theme) => {
  return {
    ...theme,
    typography: {
      ...theme.typography,
      h1: {
        fontSize: "76px",
        lineHeight: "95px",
        fontWeight: "bold",
        color: theme.palette.common.black,
        textTransform: "capitalize",
      },
      h2: {
        fontSize: "50px",
        [theme.breakpoints.down("sm")]: {
          fontSize: "26px",
        },
        lineHeight: "59px",
        fontWeight: "bold",
        color: theme.palette.common.black,
        textTransform: "capitalize",
      },
      h3: {
        fontSize: "36px",
        lineHeight: "45px",
        fontWeight: "bold",
        color: theme.palette.common.black,
        textTransform: "capitalize",
      },
      h5: {
        // feedback modal
        fontSize: "24px",
        lineHeight: "28px",
        fontStyle: "normal",
        fontWeight: "bold",
        padding: "50px 0",
        textAlign: "center",
        color: theme.palette.common.black,
      },
      h6: {
        fontSize: "24px",
        fontWeight: "bold"
      },
      subtitle1: {
        fontSize: "14px",
        lineHeight: "18px",
        fontStyle: "normal",
        fontWeight: "bold",
        color: theme.palette.common.white,
      },
      subtitle2: {
        fontSize: "24px",
        lineHeight: "28px",
        fontStyle: "normal",
        fontWeight: "bold",
        color: theme.palette.common.black,
      },
    },
  };
};

const prepareMixins = (theme) => ({
  ...theme,
  mixins: {
    toolbar: {
      [theme.breakpoints.up("md")]: {
        minHeight: 150,
      },
    },
  },
});

const prepareOverrides = (theme) => ({
  ...theme,
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: theme.palette.common.black,
      },
    },
    MuiDialog: {
      paper: {
        backgroundColor: theme.palette.common.black,
      },
    },
    MuiToolbar: {
      root: {
        backgroundColor: theme.palette.common.black,
      },
    },
    MuiButtonBase: {
      root: {
        textTransform: "capitalize",
      },
    },
    MuiTabs: {
      root: {
        backgroundColor: theme.palette.background.paper,
      },
    },
    // Style sheet name ⚛️
    MuiButton: {
      // Name of the rule
      label: {
        // Some CSS
        fontFamily: "Arial",
        fontWeight: 600,
        fontSize: "12px",
        lineHeight: "15px",
      },
    },
    MuiDialogTitle: {
      root: {
        color: theme.palette.common.white,
        textAlign: "center",
        fontWeight: "bold",
        fontStyle: "normal",
        fontSize: "24px",
        lineHeight: "45px",
        letterSpacing: "-1px",
      },
    },
    MuiDialogContentText: {
      root: {
        color: theme.palette.common.white,
        fontStyle: "normal",
        fontSize: "18px",
        lineHeight: "35px",
        letterSpacing: "-1px",
      },
    },
  },
});

export default prepareOverrides(prepareMixins(AppTypography(appTheme)));
